import { defineStore } from "pinia";
import ConversationError from "%/errors/conversation-error";

const inFlight = new Map();

// Editor-tree comment-thread cache. CommentPage production rendering
// resolves `pageEntities.comment` (URL var `message_id`) and lazy-
// fetches the message record here through the page mixin.
export const useCommentStore = defineStore("dynamic-component-editor-comment-store", {
  state: () => ({
    comments: {},
  }),
  actions: {
    async getOrFetchComment(messageId) {
      if (!messageId) {
        return null;
      }
      const cached = this.comments?.[messageId];
      if (cached?.message_id || cached?.messageId) {
        return cached;
      }
      if (inFlight.has(messageId)) {
        return await inFlight.get(messageId);
      }
      const promise = new Promise((resolve, reject) => {
        this.apiGet(
          `/message/${messageId}`,
          {},
          data => {
            // /message/{id} returns { messages: [ {..} ] } (it's used as
            // an "anchor" load that can include replies). Unwrap to the
            // first row — the element mixin only consumes one message.
            const message = Array.isArray(data?.messages) ? data.messages[0] : data;
            if (!this.comments || typeof this.comments !== "object") {
              this.comments = {};
            }
            this.comments[messageId] = message ?? null;
            resolve(message);
          },
          error => reject(new ConversationError("A comment page could not load its comment", { messageId }, error)),
        );
      }).finally(() => {
        inFlight.delete(messageId);
      });
      inFlight.set(messageId, promise);
      return await promise;
    },
  },
});
